import RegisterPhoneMediaContainer from './RegisterPhoneMediaContainer';

export default RegisterPhoneMediaContainer;
